export var Quality;
(function (Quality) {
    Quality[Quality["GOOD"] = 0] = "GOOD";
    Quality[Quality["OK"] = 1] = "OK";
    Quality[Quality["BAD"] = 2] = "BAD";
    Quality[Quality["TERRIBLE"] = 3] = "TERRIBLE";
})(Quality || (Quality = {}));
//# sourceMappingURL=statsCollector.types.js.map